import { DatePickerProvider, ThemeProvider } from '@bamboohr/fabric';
import React from 'react';

import { RecoilRoot } from 'recoil';

import { nextClassPrefix } from './_utils/next-class-prefix';
import {
	getLocale,
	getFormatTypeFromGlobalDateMask,
} from './_utils/date-picker.util';
import { getThemeName } from 'get-theme-name.util';


let uniqueClassPrefix = 'a';

/** Creates a unique class name prefix to avoid conflicting class names in JSS. */
function generateClassNamePrefix() {
	uniqueClassPrefix = nextClassPrefix(uniqueClassPrefix);
	return `jss-${uniqueClassPrefix}`;
}

/**
 * 
 * @param {React.PropsWithChildren<{ themeProps: ThemeProviderProps }>} props
 */
export function RootProviders({ children, themeProps }) {
	const { mode, themeName } = getThemeName();
	return (
		<RecoilRoot>
			<ThemeProvider
				classNamePrefix={generateClassNamePrefix()}
				{...themeProps}
				mode={mode}
				themeName={themeName}
			>
				<DatePickerProvider
					formatType={getFormatTypeFromGlobalDateMask()}
					locale={getLocale()}
				>
					{children}
				</DatePickerProvider>
			</ThemeProvider>
		</RecoilRoot>
	);
}
